import { Grid, InputLabel } from "@mui/material";
import {
  PrimaryOutlinedButton,
  PrimaryLightInput,
  PrimaryLightSelect,
} from "../../theme/index";
import "../../sass/styles.scss";
import { useDispatch } from "react-redux";
import { modalAction } from "../../redux/reducers/Modal";
import { editRoomAction, openThisRoom } from "../../redux/reducers/Edit";
import axios from "axios";
import {collection, getDoc, addDoc, query, doc} from 'firebase/firestore';
import db from "../../config/firebase";

const CleaningRoom = (props) => {
  const dispatch = useDispatch();

  const changeStatus = (room) => {
    // change room status
    const changeRoomStatus = (response) => {
      const roomEdited = new FormData();
      const dataNames = [
        "id",
        "roomNumber",
        "category",
        "price",
        "level",
        "status",
        "details",
      ];

      roomEdited.append(dataNames[0], response.id);
      roomEdited.append(dataNames[1], response.roomNumber);
      roomEdited.append(dataNames[2], response.category);
      roomEdited.append(dataNames[3], response.price);
      roomEdited.append(dataNames[4], response.level);
      roomEdited.append(dataNames[5], "open");
      roomEdited.append(dataNames[6], response.details);
      roomEdited.append("METHOD", "PUT");

      dispatch(editRoomAction(roomEdited, dataNames, response.id));

      dispatch(openThisRoom(roomEdited, dataNames, response.id));
    };

    // get room info
    const getRoomInfo = async () => {
      let response;

      const docRef = doc(db, "room", `${room.room.id}`);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        response = docSnap.data();
        //console.log("Document data:", docSnap.data());
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }

      changeRoomStatus(response);
    };

    getRoomInfo();

    dispatch(modalAction());
  };

  return (
    <>
      <Grid item xs={10}>
        <h5 style={{ margin: "0" }}>Habitación en limpieza</h5>
      </Grid>
      <Grid item xs={12}>
        <Grid container sx={{ py: 6 }}>
          <Grid item xs={12} md={6} sx={{ mb: 2 }} className="pr-2">
            <PrimaryLightInput
              label="Nombre"
              disabled
              fullWidth
              value={props.room.roomNumber}
            />
          </Grid>
          <Grid item xs={12} md={6} sx={{ mb: 2 }} className="pr-2">
            <PrimaryLightInput
              label="Tipo"
              disabled
              fullWidth
              value={props.room.category}
            />
          </Grid>
          <Grid item xs={12} md={12} className="pr-2">
            <PrimaryLightInput
              label="Detalles"
              disabled
              fullWidth
              value={props.room.details}
            />
          </Grid>
          <Grid item xs={12} sx={{ mt: 5 }} textAlign="end" className="pr-2">
            <PrimaryOutlinedButton onClick={() => changeStatus(props)}>
              Finalizar limpieza
            </PrimaryOutlinedButton>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default CleaningRoom;
